/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferred_Field_Of_StudyInputs */

const en_preferred_field_of_study = /** @type {(inputs: Preferred_Field_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Field of Study`)
};

const de_preferred_field_of_study = /** @type {(inputs: Preferred_Field_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Studienfeld`)
};

/**
* | output |
* | --- |
* | "Preferred Field of Study" |
*
* @param {Preferred_Field_Of_StudyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferred_field_of_study = /** @type {((inputs?: Preferred_Field_Of_StudyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferred_Field_Of_StudyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_preferred_field_of_study(inputs)
	return en_preferred_field_of_study(inputs)
});